<template>
  <video-player
    ref="videoPlayer"
    :playsinline="true"
    :options="playerOptions"
    @play="onPlayerPlay"
    @pause="onPlayerPause"
    @ended="onPlayerEnded()"
    @ready="playerReadied"
    class="vjs-big-play-centered" style="border:3px solid #162b44;"
  />
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import eventAPI from "@/api/event.js";
import courseAPI from "@/api/course.js";
import { EventBus } from '@/event-bus.js';
export default {
  name: "VideoPlayer",
  components: {
    videoPlayer
  },
  data() {
    return {
      id: this.$route.params.id,
      startTime: 0,
      isPlaying: false,
      confirmStart: "Do you want to carry on where you left off?",
      firstTime: true,
      intervalId: null
    };
  },
  mounted() {
    this.disableRightClick();
    this.intervalId = setInterval(() => {
      if(this.isPlaying){
        this.upadteLastWatchedTime(this.player.controlBar.currentTimeDisplay.formattedTime_);
      }
    }, 45000)
  },
  beforeDestroy() {
    // Clear the interval using the stored interval ID
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  computed: {
    playerOptions: function() {
      const options = {
        autoplay: false,
        preload: "auto",
        responsive: true,
        fluid: true,
        controls: true,
        sources: [
          {
            type: "video/mp4",
            src: this.selectedVideo.file.data.url
          }
        ]
      }
      if (this.selectedVideo.file.data.cc_path) {
        options.tracks = [
          {
            kind: "captions",
            label: "English",
            srclang: "en",
            src: this.selectedVideo.file.data.cc_path,
            default: true
          }
        ]
      }
      return options;
    },
    selectedVideo: function() {
      return this.$store.getters.currentVideo;
    },
    playVideo: function() {
      return this.$store.getters.playVideo;
    },
    entity: function() {
      return {
        related_entity: this.$store.getters.coursePlayer.id,
        related_entity_asset_id: this.selectedVideo.id,
        entity_lookup_user_id: this.$store.getters.userStats.id,
        entity_type: 1 //course
      };
    },
    totalWatchedVideos: function() {
      return this.$store.getters.userStats.watched.data.length;
    },
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  watch: {
    playVideo: {
      handler() {
        this.firstTime = true;
        this.$store.dispatch("setPlayVideo", false);
      },
      deep: true
    }
  },
  methods: {
    getCourse() {
      courseAPI
        .getCourse(this.id, "?include=enrolled,videos,documents,test,links,ppts,scorm")
        .then(response => {
          this.$store.dispatch(
            "setUserStats",
            response.data.data.enrolled.data
          );
          // this.$store.dispatch("setVideos", response.data.data);
          this.$store.dispatch('setCoursePlayer', response.data.data);
          EventBus.$emit('WATCHED_ASSETS');
        });
    },
    startPlayer(toast, player, startTime) {
      this.$snotify.remove(toast.id);
      player.currentTime(startTime);
      this.isPlaying = true;
      player.play();
    },
    onPlayerPlay(player) {
      if(this.startTime > 0 && this.firstTime && !this.selectedVideo.watched){
        this.firstTime = false;
        player.pause();
        this.$snotify.confirm(this.confirmStart, {
          backdrop:0.3,                         
          buttons: [
              { 
              text: "No",className: 'toast-cancel-button',
              action: toast => this.startPlayer(toast, player, 0)
            },
            {
               text: "Yes",className: 'toast-continue-button',
               action: toast => this.startPlayer(toast, player, this.startTime)
            }          
          ]
        });
      }else{
        this.isPlaying = true;
        if(this.$store.getters.userStats.state==1) {
          let event = this.entity;
          event.event_type = 2;
          event.event_data = null;
          eventAPI.addEvent(event).then(() => {
            //this.getCourse();
          });
        }
      }
    },
    onPlayerPause(e) {
      this.isPlaying = false;
      if(e.currentTime() > 0 && !this.selectedVideo.watched){
      this.upadteLastWatchedTime(
          this.convertDecimalToMinutesSeconds(e.currentTime())
        );
      }
    },
    onPlayerEnded() {
      this.isPlaying = false;
      let event = this.entity;
      event.event_type = 4;
      event.event_data = null;
      eventAPI.addEvent(event).then(() => {
        this.getCourse();
      });
      this.upadteLastWatchedTime('00:00')
    },
    playerReadied(player) {
      eventAPI.getLastWatchedTime(this.$store.getters.currentVideo.id).then(response => {
        this.startTime = response.data.data.time;
      });
    },
    upadteLastWatchedTime(time){
      eventAPI.upadteLastWatchedTime(this.$store.getters.currentVideo.id, time);
    },
    disableRightClick() {
      const videoElement = this.$refs.videoPlayer.$el.querySelector('video');
      if (videoElement) {
        videoElement.addEventListener('contextmenu', (event) => {
          event.preventDefault();
        });
      }
    },
    convertDecimalToMinutesSeconds(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }
  }
};
</script>
